module.exports = __webpack_public_path__ + "img/excel.0f6e0bb1.png";